<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none">
        <path
            d="M8.15649 5.48856V17.4638C8.15649 17.5913 8.1266 17.7168 8.06946 17.8292C8.01232 17.9415 7.92971 18.0373 7.82895 18.1081L6.8181 18.8174C6.72002 18.8862 6.60766 18.9292 6.49049 18.9427C6.37332 18.9563 6.25477 18.94 6.14482 18.8953C6.03488 18.8505 5.93676 18.7786 5.85873 18.6856C5.7807 18.5926 5.72504 18.4813 5.69644 18.3609L4.47833 13.2321"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M4.47825 13.232C3.50274 13.232 2.56718 12.8241 1.87739 12.098C1.1876 11.3719 0.800079 10.3871 0.800079 9.36023C0.800079 8.33337 1.1876 7.34858 1.87739 6.62248C2.56718 5.89639 3.50274 5.48847 4.47825 5.48847H8.15641C8.15641 5.48847 13.1635 5.48847 17.9818 1.23457C18.089 1.13961 18.2197 1.07883 18.3585 1.0594C18.4974 1.03996 18.6386 1.06267 18.7656 1.12486C18.8927 1.18705 19.0001 1.28612 19.0755 1.41043C19.1508 1.53474 19.1909 1.67911 19.1909 1.82657V16.8939C19.1909 17.0413 19.1508 17.1857 19.0755 17.31C19.0001 17.4343 18.8927 17.5334 18.7656 17.5956C18.6386 17.6578 18.4974 17.6805 18.3585 17.6611C18.2197 17.6416 18.089 17.5808 17.9818 17.4859C13.1634 13.232 8.15641 13.232 8.15641 13.232H4.47825Z"
            stroke="#333333"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round" />
    </svg>
</template>
<script>
export default {
    name: 'IconOfferTokens',
};
</script>
